<template>
  <div class="flex flex-col overflow-y-auto py-2" style="min-height: 24rem;">
        <!--phrase_1-->
        <div class="flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow">
            <div class="text-xs p-2 self-center"> Hi ! Please tell your problem and let me know how of how exactly are you feeling right now </div>
            <img class="h-4 w-4 mr-2 self-center opacity-75" src="../../assets/forward arrow.svg" alt="copy phrase to chat">
        </div>

        <!--phrase_1-->
        <div class="flex flex-row bg-blue-lighter mx-2 rounded font-light justify-between mb-2 flex-no-shrink flex-no-grow">
            <div class="text-xs p-2 self-center"> Hi ! Please tell your problem and let me know how of how exactly are you feeling right now </div>
            <img class="h-4 w-4 mr-2 self-center opacity-75" src="../../assets/forward arrow.svg" alt="copy phrase to chat">
        </div>

        <!--phrase_1-->
        

    </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Phrases/Custom.vue